module.exports = window.FormData



//////////////////
// WEBPACK FOOTER
// ./node_modules/isomorphic-form-data/lib/browser.js
// module id = 6092
// module chunks = 25